export const PRODUCTCATEGORY_LOADING = "PRODUCTCATEGORY_LOADING";
export const PRODUCTCATEGORY_RESET = "PRODUCTCATEGORY_RESET";
export const GET_PRODUCTCATEGORY = "GET_PRODUCTCATEGORY";
export const GET_PRODUCTCATEGORY_SUCCESS = "GET_PRODUCTCATEGORY_SUCCESS";
export const GET_PRODUCTCATEGORY_FAIL = "GET_PRODUCTCATEGORY_FAIL";
export const DELETE_PRODUCTCATEGORY = "DELETE_PRODUCTCATEGORY"
export const DELETE_PRODUCTCATEGORY_SUCCESS = "DELETE_PRODUCTCATEGORY_SUCCESS"
export const DELETE_PRODUCTCATEGORY_FAIL = "DELETE_PRODUCTCATEGORY_FAIL"
export const UPDATE_PRODUCTCATEGORY = "UPDATE_PRODUCTCATEGORY"
export const UPDATE_PRODUCTCATEGORY_SUCCESS = "UPDATE_PRODUCTCATEGORY_SUCCESS"
export const UPDATE_PRODUCTCATEGORY_FAIL = "UPDATE_PRODUCTCATEGORY_FAIL"
export const ADD_NEW_PRODUCTCATEGORY = "ADD_NEW_PRODUCTCATEGORY"
export const ADD_PRODUCTCATEGORY_SUCCESS = "ADD_PRODUCTCATEGORY_SUCCESS"
export const ADD_PRODUCTCATEGORY_FAIL = "ADD_PRODUCTCATEGORY_FAIL"